export const spacing = {
  narrow: '0.5rem',
  normal: '1rem',
  wide: '2rem',
}

export type Spacing = typeof spacing
